import { createFileRoute, Navigate } from "@tanstack/react-router";
import { adminPath } from "@/lib/adminRoute";

export const Route = createFileRoute("/pulse-ops-x7k2/logs/anomalies")({
  component: () => <Navigate to={adminPath("target-cities/performance")} replace />,
});
